import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62e22846"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "core" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "info" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "证书编号：", -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "证书发放时间：", -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "参与项目：", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 社区核心贡献者 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_typography_paragraph, null, {
        default: _withCtx(() => [
          _createTextVNode(" 感谢有你，在星汉未来开源项目中，做出突出贡献。(3个PR解锁证书) ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_row, { gutter: [40,20] }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.list, (item) => {
            return (_openBlock(), _createBlock(_component_a_col, {
              xs: 24,
              lg: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  class: "box_info",
                  target: "_blank",
                  href: item.href
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["icon", `i_${item.icon}`])
                  }, null, 2 /* CLASS */),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("p", null, _toDisplayString(item.name), 1 /* TEXT */),
                    _createElementVNode("p", null, _toDisplayString(item.path), 1 /* TEXT */),
                    _createElementVNode("p", null, [
                      _hoisted_5,
                      _createTextVNode(" " + _toDisplayString(item.num), 1 /* TEXT */)
                    ]),
                    _createElementVNode("p", null, [
                      _hoisted_6,
                      _createTextVNode(" " + _toDisplayString(item.time), 1 /* TEXT */)
                    ]),
                    _createElementVNode("p", null, [
                      _hoisted_7,
                      _createTextVNode(" " + _toDisplayString(item.project.join('、')), 1 /* TEXT */)
                    ])
                  ])
                ], 8 /* PROPS */, _hoisted_3)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}